// src/config/planAccess.js
//
// Frontend mirror of the backend capability map (be: src/config/planAccess.js).
// This only drives what the UI shows/locks, the backend is the real gate and
// answers 403 { code: "PLAN_UPGRADE_REQUIRED" } for anything not on the plan.
//
// Core is VIEW-ONLY: live Companies House search + reading stored data; no
// enrichment, scoring, AI, CRM/Duda writes, exports or API access.

export const CAP = {
  SEARCH_COMPANIES_HOUSE: "search_companies_house",
  VIEW_COMPANY_DATA: "view_company_data",
  ENRICHMENT: "enrichment",
  FINANCIALS_REFRESH: "financials_refresh",
  CRM_SYNC: "crm_sync",
  DATA_EXPORT: "data_export",
  API_ACCESS: "api_access",
  OPPORTUNITY_SCORE: "opportunity_score",
  REVENUE_INTELLIGENCE: "revenue_intelligence",
};

const CORE = [CAP.SEARCH_COMPANIES_HOUSE, CAP.VIEW_COMPANY_DATA];
const GROW = [
  ...CORE,
  CAP.ENRICHMENT,
  CAP.FINANCIALS_REFRESH,
  CAP.CRM_SYNC,
  CAP.DATA_EXPORT,
  CAP.API_ACCESS,
];
const AI = [...GROW, CAP.OPPORTUNITY_SCORE, CAP.REVENUE_INTELLIGENCE];

export const PLAN_CAPABILITIES = {
  axo_core: CORE,
  axo_grow: GROW,
  axo_ai: AI,
  axo_enterprise: AI,
};

export const PLAN_LABELS = {
  axo_core: "Core",
  axo_grow: "Grow",
  axo_ai: "AI",
  axo_enterprise: "Enterprise",
};

// Mirror of Backend/src/config/plans.js. Prices, seats and limits must not be
// duplicated elsewhere in the UI.
export const PLAN_META = {
  axo_core: {
    name: "AXO Core",
    priceGbp: 29,
    maxUsers: 1,
    maxLeadsPerMonth: 1000,
    includedCreditGbp: 0,
  },
  axo_grow: {
    name: "AXO Grow",
    priceGbp: 99,
    maxUsers: 5,
    maxLeadsPerMonth: 2500,
    includedCreditGbp: 0,
  },
  axo_ai: {
    name: "AXO AI",
    priceGbp: 299,
    maxUsers: 10,
    maxLeadsPerMonth: 5000,
    includedCreditGbp: 25,
  },
  axo_enterprise: {
    name: "AXO Enterprise",
    priceGbp: 1250,
    maxUsers: 999,
    maxLeadsPerMonth: 999999,
    includedCreditGbp: 25,
  },
};

// Lowest plan that unlocks each capability, used for "Available on Grow" copy.
export const MIN_PLAN_FOR = {
  [CAP.ENRICHMENT]: "axo_grow",
  [CAP.FINANCIALS_REFRESH]: "axo_grow",
  [CAP.CRM_SYNC]: "axo_grow",
  [CAP.DATA_EXPORT]: "axo_grow",
  [CAP.API_ACCESS]: "axo_grow",
  [CAP.OPPORTUNITY_SCORE]: "axo_ai",
  [CAP.REVENUE_INTELLIGENCE]: "axo_ai",
};

// Customers created before the Core/Grow/AI/Enterprise rename.
const LEGACY_PLAN_ALIASES = {
  axo_launch: "axo_core",
  axo_momentum: "axo_grow",
  axo_scale: "axo_ai",
};

export const INTERNAL_DOMAINS = ["peachloves.co.uk", "peachlovesdigital.co.uk"];

export function normalisePlanId(planId) {
  if (!planId) return "axo_core";
  const mapped = LEGACY_PLAN_ALIASES[planId] || planId;
  return PLAN_CAPABILITIES[mapped] ? mapped : "axo_core";
}
